import { useState } from 'react';  
import { useTeamBadgePdf } from '#root/queries/badges';  
import { showToast } from "#root/components/GlobalToaster";
import { downloadBlob } from '#root/services/utils';

interface UseTeamBadgePrintingResult {  
    printTeamBadge: (usarTeamNumber: number, incidentId: string) => Promise<void>;
    isPrinting: boolean;  
    printingNumber?: number;  
}  
  
export const useTeamBadgePrinting = (): UseTeamBadgePrintingResult => {  
    const [printingNumber, setPrintingNumber] = useState<number | undefined>(undefined);  
    const teamBadgeMutation = useTeamBadgePdf();  
  
    const printTeamBadge = async (usarTeamNumber: number, incidentId: string) => {  
        setPrintingNumber(usarTeamNumber);  
        try {  
            const pdfBlob = await teamBadgeMutation.mutateAsync({ usarTeamNumber, incidentId });
            if (pdfBlob) {  
                downloadBlob(pdfBlob, `USAR_Team_${usarTeamNumber}_badge.pdf`);  
            }  
        } catch (err) {  
            showToast('Team badge generation failed.', 'error');  
            throw err;  
        } finally {  
            setPrintingNumber(undefined);  
        }  
    };  
  
    return {  
        printTeamBadge,  
        isPrinting: teamBadgeMutation.isPending,  
        printingNumber,  
    };  
};
